export default __webpack_public_path__ + "static/media/referralCode.808a0846.png";